import styled from "styled-components"
import Dropzone from "react-dropzone"

import buttonCss from "../styled"

export default styled(Dropzone)`
  ${buttonCss};
  width: 100%;
`
